// @flow
/** @jsx h */

import { h, Component } from 'preact'

import styles from './Loader.css'

type Props = {
  children?: ?any
}

export class Loader extends Component<Props> {
  render () {
    return <div className={styles.loader}>{this.props.children}</div>
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/Loader/Loader.js